import React from 'react';
import { Wrapper, Section } from './styles';

const PageWithTopbar = ({
  children,
  leftComponent,
  midComponent,
  rightComponent,
  leftSpan,
  midSpan,
  rightSpan,
  wrappadding,
  ...rest
}) => (
  <>
    <Wrapper
      px={2}
      borderBottom="1px solid"
      borderColor="greyscale.3"
      {...rest}
    >
      <Section wrappadding={wrappadding} span={leftSpan || (midComponent ? 8 : 12)}>
        {leftComponent}
      </Section>
      {
        midComponent && (
          <Section wrappadding={wrappadding} span={midSpan || 8} justifyContent="center">
            {midComponent}
          </Section>
        )
      }
      <Section wrappadding={wrappadding} span={rightSpan || (midComponent ? 8 : 12)} justifyContent="flex-end">
        {rightComponent}
      </Section>
    </Wrapper>
    {children}
  </>
);

export default PageWithTopbar;
